import {useQueries} from "@tanstack/react-query";
import dispatchImageReservationService from "../../../../services/web/dispatch-image-reservation-service.js";


const UseFetchOptions = () => {

    const queries = useQueries({
        queries: [
            {
                queryKey: ['cause'],
                queryFn: () => dispatchImageReservationService.getCauses().then(data => [{ label: "Não informado", value: "WITHOUT-CAUSE" }, ...data]),
                initialData: []
            }
        ]
    });

    return {
        causeOptions: queries[0].data
    };
};

export default UseFetchOptions;